import "./DiscountList.scss";

import React from "react";
import { Link } from "react-router-dom";
import usesFeatures from "usesFeatures"
import request from "request"

import Icon from "Icon"
import Table from "Table"
import Header from "Header"

class DiscountList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.fetchData("/venue_admin/discounts")
  }

  DiscountsFor = (category=null) => {
    return this.props.discounts
  }

  emptyTable = () => {
    return(
      <h3 className="is-size-6 is-italic">
        No Discounts Found. Time to <Link to={`/Discounts/new`}>create one</Link>?
      </h3>
    )
  }

  clearOrder = () => this.setState({isOrdering: false})

  DiscountHeaders = () => {
    const headers = {
      // Order is disabled for now, I'm not sure we need it and I don't want to be frivolous with the DB schema
      // up: "",
      // down: "",
      name: "Discount Name",
      discount_amount: "Amount",
      edit: "",
    }

    if(this.props.externalMenus) {
      // delete headers.up
      // delete headers.down
      delete headers.edit
    }

    return headers
  }

  DiscountFormatters = () => {
    return(
      {
        up: (p) => p.isFirst ? null : <Icon icon="chevron-up" onClick={this.moveDiscount.bind(null, p.id, -1)} />,
        down: (p) => p.isLast ? null : <Icon icon="chevron-down" onClick={this.moveDiscount.bind(null, p.id, 1)} />,
        name: (p) => <Link to={`/Discounts/${p.id}`}>{p.name}</Link>,
        discount_amount: (p) => p.discountUnit === "percent" ? `${p.discountAmount}%` : `$${p.discountAmount}`,
        edit: (p) => <Link to={`/Discounts/${p.id}/edit`}>Edit</Link>,
      }
    )
  }

  moveDiscount = (DiscountId, direction) => {
    if (this.state.isOrdering) return
    this.setState({isOrdering: true })
    let req = request.post(`/venue_admin/discounts/${DiscountId}/move`, { direction })
    req.then(({data}) => {
      this.props.fetchData("/venue_admin/discounts", this.clearOrder)
    })
  }

  render() {
    if (!this.props.dataFetched) return false

    const categories = ["percent", "dollar"]
    return(
      <div className="DiscountList">
        <Header
          text="Discounts"
          actions={true}
        >
          <Link to="/Discounts/new" className="button is-primary">New Discount</Link>
        </Header>
          <div key='discountstable' className="block">
            <h3 className="title">Discounts</h3>
            <Table
              empty={this.emptyTable()}
              showHeader={true}
              headers={this.DiscountHeaders()}
              formatters={this.DiscountFormatters()}
              rows={this.DiscountsFor()}
              tdClasses={TD_CLASSES}
            />
          </div>
      </div>
    )
  }
}

const TD_CLASSES = {
  up: "is-narrow",
  down: "is-narrow",
  discount_amount: "is-narrow pr-4",
  edit: "is-narrow"
}

export default usesFeatures(["data"], DiscountList)
